import React from 'react';
import { Shield, Lock, Clock, Camera } from 'lucide-react';
export function Security() {
  const securityFeatures = [{
    icon: <Shield className="h-6 w-6 sm:h-7 sm:w-7 text-primary" data-id="element-334" />,
    title: '100% EU-hosted infrastructure',
    description: 'All test data is stored on European servers for maximum privacy protection.'
  }, {
    icon: <Lock className="h-6 w-6 sm:h-7 sm:w-7 text-primary" data-id="element-335" />,
    title: 'GDPR compliant',
    description: 'Our platform is built with privacy-by-design principles and full GDPR compliance.'
  }, {
    icon: <Clock className="h-6 w-6 sm:h-7 sm:w-7 text-primary" data-id="element-336" />,
    title: 'Automatic data deletion',
    description: 'All candidate data is automatically deleted after 90 days.'
  }, {
    icon: <Camera className="h-6 w-6 sm:h-7 sm:w-7 text-primary" data-id="element-337" />,
    title: 'Optional webcam consent',
    description: 'Webcam monitoring is optional and never stored permanently.'
  }];
  return <section className="py-12 md:py-20 bg-gray-50" data-id="element-338">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-339">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 sm:mb-4" data-id="element-340">
          How Do We Protect Candidate Data?
        </h2>
        <p className="text-sm sm:text-base text-center text-gray-600 mb-12 sm:mb-16 max-w-2xl mx-auto px-4" data-id="element-341">
          All candidate data is EU-hosted and GDPR compliant. We take privacy
          and security seriously — your candidates' information is protected at
          every step.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-342">
          {securityFeatures.map((feature, index) => <div key={index} className="bg-white p-6 sm:p-8 rounded-xl border border-gray-200" data-id="element-343">
              <div className="mb-4 sm:mb-5 bg-gray-50 p-2.5 sm:p-3 inline-block rounded-full" data-id="element-344">
                {feature.icon}
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3" data-id="element-345">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600" data-id="element-346">
                {feature.description}
              </p>
            </div>)}
        </div>
        <div className="mt-8 sm:mt-12 flex justify-center" data-id="element-347">
          <div className="inline-flex items-center px-4 sm:px-5 py-2.5 sm:py-3 bg-gray-100 rounded-lg border border-gray-200" data-id="element-348">
            <Lock size={16} className="text-primary mr-2 sm:mr-3" data-id="element-349" />
            <span className="font-medium text-sm sm:text-base" data-id="element-350">
              Secure & GDPR Compliant
            </span>
          </div>
        </div>
      </div>
    </section>;
}